import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  root: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-around',
  },
  container: {
    textAlign: 'center',
    background: 'white',
    height: 150,
    width: 420,
    padding: 30,
  },
  cancelButton: {
    fontWeight: 'bold',
    color: '#505255',
    border: '1px solid #003366',
  },
  confirmButton: {
    background: '#003366',
    fontWeight: 'bold',
    border: '1px solid #003366',
    color: 'white',
    '&:hover': {
      color: '#003366',
    },
  },
  message: {
    fontSize: 16,
    fontWeight: 400,
    marginBottom: 21,
  },
}));
